'use client';

import NextLink from 'next/link';
import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { APP_ROUTE_PATHS, PUBLIC_ROUTES } from '@/configs/routes';
import { blue } from '@/lib/colours';
import { useAdminGuard } from '@/hooks/useAdminGuard';

const RegistryCardLink = styled(NextLink)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  height: '100%',
  textDecoration: 'none',
  borderRadius: '16px',
  '&:focus-visible': {
    outline: `2px solid ${blue[400]}`,
    outlineOffset: 3,
  },
}));

type RegistryGetStartedCardLinkProps = {
  ariaDescribedby: string;
  ariaLabelledby: string;
  children: ReactNode;
};

export function RegistryGetStartedCardLink({
  ariaDescribedby,
  ariaLabelledby,
  children,
}: RegistryGetStartedCardLinkProps) {
  const { handleClickLink } = useAdminGuard(APP_ROUTE_PATHS.DASHBOARD);

  return (
    <RegistryCardLink
      aria-describedby={ariaDescribedby}
      aria-labelledby={ariaLabelledby}
      href={PUBLIC_ROUTES.REGISTRY_LANDING}
      onClick={handleClickLink}
    >
      {children}
    </RegistryCardLink>
  );
}
